<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v1H2V2h6v1a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1zm11.707 4.293a1 1 0 0 0-1.414 1.414L12.586 7H5a1 1 0 0 0 0 2h7.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414z"
      fill="var(--base-error-color)"
      fill-rule="evenodd"
    />
  </svg>
</template>
